import { WordPressPostCategoryModel } from './post-category.model';
import { WordPressPostTagModel } from './post-tag.model';
import { Model } from '../model';
import { format } from 'date-fns';

export class WordPressPostModel extends Model {
  /**
   * The authors of the post.
   */
  get authors(): any[] {
    return this._embedded?.author;
  }

  set authors(value: any) {}

  /**
   * The categories of the post.
   */
  get categories(): WordPressPostCategoryModel[] {
    return this._embedded?.["wp:term"]
      .reduce((acc: any[], curr: any[]) => acc.concat(curr), [])
      .filter((term: any) => term.taxonomy === "category")
      .map((term: any) => new WordPressPostCategoryModel(term));
  }

  set categories(value: any) {}

  /**
   * The content of the post.
   */
  content?: { rendered: string };

  /**
   * The custom fields of the post.
   */
  custom_fields: any;

  /**
   * The timestamp of when the post was published.
   */
  date?: string;

  /**
   * Embdedded data about the post.
   */
  _embedded?: any;

  /**
   * The excerpt of the post.
   */
  excerpt?: { rendered: string };

  /**
   * The featured image of the post.
   */
  get featured_image(): any {
    return this._embedded?.["wp:featuredmedia"]?.[0];
  }

  /**
   * The image to use for the background of the post's header.
   */
  header_background_image: any;

  /**
   * The id of the model.
   */
  id?: number;

  /**
   * The timestamp of when the post was modified.
   */
  modified?: string;

  /**
   * The route of the model.
   */
  route?: string | string[];

  /**
   * The slug of the post.
   */
  slug?: string;

  /**
   * The categories of the post.
   */
  get tags(): WordPressPostTagModel[] {
    return this._embedded?.["wp:term"]
      .reduce((acc: any[], curr: any[]) => acc.concat(curr), [])
      .filter((term: any) => term.taxonomy === "post_tag")
      .map((term: any) => new WordPressPostTagModel(term));
  }

  set tags(value: any) {}

  /**
   * The title of the post.
   */
  title?: { rendered: string };

  /**
   * The time stamp string.
   */
  get timestamp(): any {
    if (this.date) {
      return format(new Date(this.date), "MMMM d, yyyy");
    }
  }

  /**
   * Handle model booted.
   */
  booted() {
    this.route = ["/blog", `${this.slug}-${this.id}`];
  }
}
